$(function(){
  $('.js-tab-controller li').on('click', function(){
    $('.js-tab-controller li').each(function(){
      $(this).removeClass('active');
    });
    $(this).addClass('active');
    var target = $(this).data('tab-target');
    $('.js-tab-content').each(function () {
      if ($(this).data('tab-content') == target) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });
  });
});